module.exports = __webpack_public_path__ + "static/img/cocina_06.b87a9eab.jpeg";